















import { defineComponent, computed } from '@vue/composition-api';
import SharedState from '@/data/SharedState';
export default defineComponent({
  props: {
    count: {
      type: Number,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    loadingError: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const text = computed(() => {

      if(props.isLoading) {
        return SharedState.getText(context, 'corptube.videocount.loading');
      }
      if(props.loadingError) {
        return SharedState.getText(context, 'corptube.videocount.error');
      }
      
      if(props.count === 0) {
        return SharedState.getText(context, 'corptube.videos.none');
      }

      return props.count === 1
        ? SharedState.getText(context, 'corptube.video')
        : SharedState.getText(context, 'corptube.videos');
    });
    return {
      text
    };
  }
})
